import { toast } from 'sonner';
import { useFileUpload } from '@/lib/upload/useFileUpload.ts';
import consentTemplatesApi from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.ts';

interface ConsentFileUploadResult {
  fileId: string;
  fileName: string;
}
// todo is this logic G?
export default function useUploadConsentFile() {
  let capturedFileName = '';

  return useFileUpload<ConsentFileUploadResult>({
    initUpload: async (request) => {
      capturedFileName = request.fileName;
      return consentTemplatesApi.initFileUpload(request);
    },
    processUpload: async (fileId: string) => {
      await consentTemplatesApi.confirmFileUpload(fileId);
      return { fileId, fileName: capturedFileName };
    },
    onError: (error: Error) => {
      toast.error('Błąd przesyłania', {
        description:
          error.message || 'Wystąpił błąd podczas przesyłania pliku.',
      });
    },
  });
}
